export const event = (action: string) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', action)
  } else {
    console.log('[analytics]', action)
  }
}
